import { Component, OnInit, Input, Inject } from '@angular/core';
import { Service } from 'app/modules/admin/services/service.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CalendarYearDetailServiceComponent } from '../calendar-year-detail-service/calendar-year-detail-service.component';

@Component({
  selector: 'app-calendar-year-select-service',
  templateUrl: './calendar-year-select-service.component.html',
  styleUrls: ['./calendar-year-select-service.component.css']
})
export class CalendarYearSelectServiceComponent implements OnInit {
 
  @Input() public services: Service[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialogRef: MatDialogRef<CalendarYearSelectServiceComponent>,
    public dialog: MatDialog,
    ) { }

  ngOnInit() {
    console.log(this.data);
  }

  public selectService(service: Service) {
    console.log(service);

    const dialogRef = this.dialog.open(CalendarYearDetailServiceComponent, {
      data: {
        service: service, 
        date: this.data.date,
        liturgyType: this.data.liturgyType
      },
    });

    //We don't need multiple dialogs. 
    //Once the user has selected a service, close this dialog screen
    this.dialogRef.close();
     
  }

} 
